import React, { Fragment } from 'react';

import { FormattedMessage } from 'react-intl';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { showModal } from '@actions/common/actionCreators';

const TicketQuickActionBar = props => {
    const {
        ticketData
    } = props;
    const showCurrentTask = (ticketData.status === 'Open' || ticketData.status === 'Unclaimed' ||ticketData.status === 'Restarted' || ticketData.status === 'Reopened' );



    return (
        <Fragment>
            <table className='table table-striped' data-automation-id='tbl_ticket_mgmt_quick_action_bar'>
                <tbody>
                    <tr>
                        <td>
                            <strong>
                                <FormattedMessage id='ticket_management_ticket_status'/>
                            </strong>
                            <FormattedMessage id='ticket_management_non_inter_text' values={{ text: ticketData.ticketStatus }}/>
                        </td>
                        {   ticketData.assignee &&
                            <td>
                                <strong>
                                    <FormattedMessage id='ticket_management_assignee'/>
                                </strong>
                                <FormattedMessage id='ticket_management_non_inter_text' values={{ text: ticketData.assignee }}/>
                            </td>
                        }
                        {   showCurrentTask &&
                            <td>
                                <strong>
                                    <FormattedMessage id='ticket_management_ticket_current_task'/>
                                </strong>
                                <FormattedMessage id='ticket_management_non_inter_text' values={{ text: ticketData.currentTask }}/>
                            </td>
                        }

                        { ticketData.ticketStatus === 'Claimed' &&
                            <Fragment>
                                <td>
                                </td>
                                <td>
                                </td>
                                <td>
                                </td>
                            </Fragment>

                        }
                        { ticketData.ticketStatus === 'UnClaimed' &&
                            <Fragment>
                                <td>
                                </td>
                            </Fragment>
                        }
                        { (ticketData.ticketStatus !== 'Claimed' && ticketData.status !== 'UnClaimed') &&
                            <td></td>
                        }
                    </tr>
                </tbody>
            </table>
        </Fragment>
    );
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        showModal
    }, dispatch)
});

export default connect(null, mapDispatchToProps)(TicketQuickActionBar);